import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "showIcon", "hideIcon"]

  connect() {
    this.inputTarget.classList.add("pr-10")

    // Move bottom border from input to wrapper so it spans under the icon
    const wrapper = this.inputTarget.parentElement
    const inputStyles = getComputedStyle(this.inputTarget)
    const borderColor = inputStyles.borderBottomColor
    const borderWidth = inputStyles.borderBottomWidth

    wrapper.style.borderBottom = `${borderWidth} solid ${borderColor}`
    this.inputTarget.style.borderBottom = "none"
  }

  toggle() {
    const isPassword = this.inputTarget.type === "password"
    this.inputTarget.type = isPassword ? "text" : "password"
    this.showIconTarget.classList.toggle("hidden", !isPassword)
    this.hideIconTarget.classList.toggle("hidden", isPassword)
  }
}
